import React from "react";
import Swiper from "react-id-swiper";
import I18n from "../../../i18n/I18n";
import Title from "../../common/widgetTitle/WidgetTitle";
import ProductBox from "../../common/productBox/ProductBox";
import styles from "./TopProducts.scss";

const TopProducts = (props: Object) => {
  const products = props.products || "";

  const params = {
    paginationClickable: false,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev"
    },
    containerClass: styles.containerClass,
    spaceBetween: 10,
    shouldSwiperUpdate: true,
    rebuildOnUpdate: true,
    loop: true
  };

  const browser = props.browser;

  let slidesCount = 5;

  if (browser.lessThan.phablet) {
    slidesCount = 1.8;
  } else if (browser.lessThan.tablet) {
    slidesCount = 3.5;
  } else if (browser.greaterThan.largeDesktop) {
    slidesCount = 8;
  }

  const productList = products
    ? products.map((product, index) => (
        <div key={index}>
          <ProductBox
            product={product}
            index={index + 1}
            lang={props.lang}
            currencyCode={props.currencyCode}
          />
        </div>
      ))
    : "";

  return (
    <div className={styles.ctr}>
      <Title
        title={I18n.getText(
          "dashboard.top-products",
          {},
          "Top Selling Products"
        )}
        // enableBtn
        // btnText={I18n.getText('dashboard.view-all', {}, 'View All')}
        // btnLink={'/products'}
      />

      <Swiper
        {...params}
        containerClass={styles.horizontalContainer}
        slidesPerView={slidesCount}
      >
        {productList}
      </Swiper>
    </div>
  );
};

export default TopProducts;



// WEBPACK FOOTER //
// ./src/components/dashboard/topProducts/TopProducts.js